import { GROUPED_STATIC_TEXT_ROLE } from '../../../../components/ui-components/NameValueTableRow'
import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'
import AdvanceTaxCard from './AdvanceTaxCard'
import { mfLogoBaseUrl } from '../../../../env'

type TaxLiabilityHeaderProps = {
  totalTaxLiability: number
  isUserElite: boolean
  isCurrentFinancialYear: boolean
}

const MASKED_CURRENCY = '₹****'

export function TaxLiabilityHeader({ totalTaxLiability, isUserElite, isCurrentFinancialYear }: TaxLiabilityHeaderProps) {
  const displayTaxLiability = isUserElite
    ? roundOffAndFormatNumberWithCurrency(totalTaxLiability)
    : MASKED_CURRENCY

  return (
    <div className='relative z-0 mb-8 flex flex-col items-stretch gap-4 overflow-hidden bg-[#FFF2DF] p-4'>
      <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 right-0 z-[-1] flex items-start justify-end'>
        <img src={`${mfLogoBaseUrl}/images/tax.png`} alt='' className='max-h-full h-auto w-auto object-contain' />
      </div>
      <div className='relative z-1 flex flex-1 flex-row justify-between'>
        <div className='flex min-w-0 w-full flex-1 flex-col justify-center'>
          <div>
            <div
              role={GROUPED_STATIC_TEXT_ROLE}
              aria-label={`Total tax liability, ${displayTaxLiability}`}
            >
              <p aria-hidden='true' className='text-13 font-base leading-[1.4] text-[#992E00]'>Total tax liability</p>
              <p aria-hidden='true' className='text-[32px] font-[500] leading-[1.4] text-[#992E00]'>
                {displayTaxLiability}
              </p>
            </div>
            {isUserElite ? (
              totalTaxLiability >= 10000 && isCurrentFinancialYear ? (
                <p className='text-13 font-base leading-[1.4] text-[#992E00] mt-2'>
                  Total tax liability exceeds ₹10,000 <br /> so you need to pay tax in advance
                </p>
              ) :totalTaxLiability > 0? (
                <p className='text-13 font-base leading-[1.4] text-[#992E00] mt-2'>
                  Overall tax liability on the capital <br /> gains realised this FY
                </p>
              ) : null
            ) : null}
          </div>
        </div>
      </div>
      {/* {isCurrentFinancialYear && totalTaxLiability > 0 ? (
        <AdvanceTaxCard totalTaxLiability={totalTaxLiability} />
      ) : null} */}
    </div>
  )
}
